export default "__VITE_ASSET__DBCMNES3__"